export const fileNames = [
  'diment-iconmark-blue',
  'diment-iconmark-white',
  'diment-logotext-blue',
  'diment-logotext-white',
  'diment-text-blue',
  'diment-text-white',
];
